// removed by extract-text-webpack-plugin
module.exports = {"root":"_w-DTW","fadeIn":"_2Bqs4","text":"_VoKlC","icon":"_QN82Z","jelly":"_3XdIB","slideInLeft":"_28VQF","slideInUp":"_3JTtM","pop-in":"_njm-K","spin":"_FXNnz"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PaymentHandler/BraintreeCheckout/components/BraintreeLoader/BraintreeLoader.scss
// module id = 1532
// module chunks = 1